/**
 * Cookie Banner Fallback Script
 * Ensures cookie banner is always visible and functional
 */

document.addEventListener('DOMContentLoaded', function () {
  // Wait a bit for CSS to load
  setTimeout(function () {
    ensureCookieBannerVisibility();
  }, 100);
});

// Also run on window load as a fallback
window.addEventListener('load', function () {
  setTimeout(function () {
    ensureCookieBannerVisibility();
  }, 200);
});

function ensureCookieBannerVisibility() {
  const cookieNotice = document.getElementById('cookie-notice');
  const darkOverlay = document.querySelector('.dark-overlay');

  // Only proceed if both elements exist (meaning cookies haven't been accepted/rejected)
  if (!cookieNotice || !darkOverlay) {
    return;
  }

  // Check if cookie banner is actually visible
  const cookieRect = cookieNotice.getBoundingClientRect();
  const isVisible = cookieRect.width > 0 && cookieRect.height > 0;
  const computedStyle = window.getComputedStyle(cookieNotice);
  const isDisplayed = computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden';

  if (!isVisible || !isDisplayed) {
    console.warn('Cookie banner not visible, applying fallback styles');

    // Force visibility with inline styles
    cookieNotice.style.cssText = `
      position: fixed !important;
      bottom: 0 !important;
      right: 0 !important;
      z-index: 10001 !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      background: white !important;
      width: 100% !important;
      min-height: 80px !important;
      padding: 2rem !important;
      box-shadow: 0 -2px 10px rgba(0,0,0,0.1) !important;
    `;

    // Ensure buttons are clickable
    const buttons = cookieNotice.querySelectorAll('button, input[type="submit"]');
    buttons.forEach((button) => {
      button.style.cssText = `
        pointer-events: auto !important;
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        z-index: 10002 !important;
      `;
    });
  }

  // Ensure dark overlay is properly positioned
  if (darkOverlay) {
    darkOverlay.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      background: rgba(45, 45, 50, 0.5) !important;
      z-index: 10000 !important;
      pointer-events: auto !important;
    `;
  }

  // Add click handler to dark overlay to prevent interactions
  if (darkOverlay) {
    darkOverlay.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Flash the cookie banner to draw attention
      if (cookieNotice) {
        cookieNotice.style.animation = 'cookieBannerFlash 0.5s ease-in-out';
        setTimeout(() => {
          cookieNotice.style.animation = '';
        }, 500);
      }
    });
  }
}

// Add CSS animation for flashing effect
const style = document.createElement('style');
style.textContent = `
  @keyframes cookieBannerFlash {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.02); box-shadow: 0 0 20px rgba(38, 96, 95, 0.3); }
  }
`;
document.head.appendChild(style);

// Export for potential manual triggering
window.ensureCookieBannerVisibility = ensureCookieBannerVisibility;
